/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';

export const GetMemberDetails = zod.object({
  "id": zod.string().uuid().optional()
});

export type GetMemberDetails = zod.input<typeof GetMemberDetails>;
export type GetMemberDetailsOutput = zod.output<typeof GetMemberDetails>;
